module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/e8ee68ea41fa9b24b73d36f2f5683331.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_assign-end.svg
// module id = ar8F
// module chunks = 0